import {Timeline} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenaten} from "../../TombOfAkhenaten";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TOATimelineReelsController} from "../../reel/TOATimelineReelsController";
import {TombOfAkhenatenGameModuleConfig} from "../../TombOfAkhenatenGameModuleConfig";
import {SpinningPyramid} from "../../feature/SpinningPyramid";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class ReelStart implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    private readonly _reelId:number;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;

        this._reelId = reelId;
    }

    public getAnimation(data:TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData):Timeline | null {
        if(TombOfAkhenatenGameConfig.instance.WINNING_SYMS_STICKY && data.stickySymbols[this._reelId][0].indexOf("X") === -1) {
            return (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).onStartSpin(this._reelId, true);
        }
        // if((<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController)._isNextFinalSpin){
        //     if(TombOfAkhenatenGameModuleConfig.canPyramidStopParallelly){
        //         const activeReels : number = (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).finalSpinActiveReels[Math.floor(this._reelId/5)];
        //         this.stagger = activeReels > 0 ? SpinningPyramid.START_INTERVAL / activeReels : 0;
        //         //Logger.log("reel Id : "+this._reelId+" stagger in spin start : "+this.stagger);
        //     }else{
        //         //this.stagger = undefined
        //     }
        // }
        return (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController).onStartSpin(this._reelId, false);
    }
}